import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Field } from 'react-final-form';
import { propBool, propChildren, propFunc, propId, propStr, } from '../../../../../../../helpers/custom-prop-types';
const SeminarOneFormCheckBoxField = (props) => {
    const { checkboxLabel, checkboxValue, className, disabled, inputClassName, name, validate, } = props;
    const id = `${name}_${checkboxValue}`;
    return (_jsx("div", Object.assign({ className: clsx('professional_seminar_one_form_checkbox field', className) }, { children: _jsx("div", Object.assign({ className: 'checkbox_wrapper' }, { children: _jsx("label", Object.assign({ className: clsx('checkbox_label', !disabled && 'pointer') }, { children: _jsxs("span", Object.assign({ className: 'checkbox_inner' }, { children: [_jsx(Field, { className: clsx('checkbox_input', inputClassName), component: 'input', disabled: disabled, id: id, name: name, type: 'checkbox', validate: validate, value: checkboxValue }), _jsx("i", {}), _jsx("span", Object.assign({ className: 'checkbox_text' }, { children: checkboxLabel }))] })) })) })) })));
};
SeminarOneFormCheckBoxField.propTypes = {
    checkboxLabel: propChildren().isRequired,
    checkboxValue: propId().isRequired,
    className: propStr(),
    disabled: propBool(),
    inputClassName: propStr(),
    name: propStr().isRequired,
    validate: propFunc(),
};
SeminarOneFormCheckBoxField.defaultProps = {
    className: '',
    disabled: false,
    inputClassName: '',
    validate: undefined,
};
export default SeminarOneFormCheckBoxField;
